export const inches = [
    {
        value: "0.5"
    },
    {
        value: "0.6"
    },
    {
        value: "0.7"
    },
    {
        value: "0.75"
    },
    {
        value: "0.8"
    },
    {
        value: "0.9"
    },
    {
        value: "1.0"
    },
    {
        value: "1.1"
    },
    {
        value: "1.2"
    },
    {
        value: "1.25"
    },
    {
        value: "1.3"
    },
    {
        value: "1.4"
    },
    {
        value: "1.5"
    },
    {
        value: "1.75"
    },
    {
        value: "1.8"
    },
    {
        value: "1.9"
    },
    {
        value: "2.0"
    },
    {
        value: "2.25"
    },
    {
        value: "2.5"
    },
];